import React from 'react';
import { Link } from 'react-router-dom';
import NECSLogo from './NECSLogo';

/**
 * Shared header for public utility pages (Contact, Privacy Policy, Terms of Service).
 * Mirrors the landing-page navbar:
 *   - Black (#2D2D2D) box anchoring the NECS logo on the far left
 *   - Gold (#C9A962) bar extending across the rest of the row
 *   - "Back to home" link on the right side of the gold bar
 */
export default function PublicPageNav({ testIdPrefix = 'public-page' }) {
  return (
    <nav
      className="w-full border-b"
      style={{ backgroundColor: '#C9A962', borderColor: '#2D2D2D' }}
      data-testid={`${testIdPrefix}-nav`}
    >
      <div className="flex justify-between items-stretch h-20 sm:h-24 pr-4 sm:pr-6 lg:pr-8">
        {/* Left: black logo block */}
        <Link
          to="/"
          className="flex items-center h-full pl-0"
          style={{ backgroundColor: '#2D2D2D' }}
          data-testid={`${testIdPrefix}-back-home`}
          aria-label="Back to home"
        >
          <NECSLogo
            variant="header"
            size="sm"
            align="left"
            dataTestId={`${testIdPrefix}-logo`}
            className="h-full"
          />
        </Link>

        {/* Right: back to home link on the gold bar */}
        <div className="flex items-center">
          <Link
            to="/"
            className="inline-flex items-center font-bold text-xs sm:text-sm h-11 px-7 sm:px-9 rounded-full text-white bg-black hover:opacity-90 transition uppercase tracking-wider"
            style={{ fontFamily: 'Barlow Condensed, sans-serif', letterSpacing: '0.15em' }}
            data-testid={`${testIdPrefix}-back-link`}
            title="Back to home"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </nav>
  );
}
